import { connect } from "react-redux";
import LoyaltyNewInBannerItem from "./LoyaltyNewInBannerItem";

import {
  getDefaultStoreUrl,
  getStoreCode
} from "@template/state/modules/regionalStore";
import { isMale } from "@template/state/modules/layout";
import { getLoyaltyStatus } from "@template/state/modules/loyalty";
import { isLoggedIn } from "@template/state/modules/user";

function mapStateToProps(state) {
  const loyaltyStatus = getLoyaltyStatus(state);
  return {
    defaultStoreUrl: getDefaultStoreUrl(state),
    enableComplianceVariant: loyaltyStatus.enableComplianceVariant,
    isMale: isMale(state),
    isOptedIn: loyaltyStatus.optedIn,
    itemCount: loyaltyStatus.itemCount,
    loggedIn: isLoggedIn(state),
    storeCode: getStoreCode(state)
  };
}

export default connect(mapStateToProps)(LoyaltyNewInBannerItem);
